/* global ga */

function sendEvent(method, type, event) {
  if (typeof ga !== "undefined") {
    ga(method, type, event)
  }
}

export default sendEvent
